<template>
  <v-app>
    <v-app-bar
      app
      light
    >
      <div class="d-flex align-center">
        <a href="/">
          <v-img
            alt="1799 Logo"
            class="shrink mt-1"
            contain
            min-width="100"
            src="@/assets/images/1799_logo_h.png"
            width="100"
          />
        </a>
      </div>

      <v-spacer></v-spacer>
    </v-app-bar>
    <v-main>
      <Form/>
    </v-main>
  </v-app>
</template>

<script>
import Form from './components/Form'

export default {
  name: 'App',

  components: {
    Form
  },

  data: () => ({
    //
  })
}
</script>

<style>
  @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@300;500;700&display=swap');

  * {
    font-family: 'Noto Sans TC', sans-serif;
  }
</style>
